import React, {ReactElement, useState} from "react"
import {notification} from "antd"
import {observer} from "mobx-react-lite"
import {useStore} from "@ui/stores"
import {t} from "@ui/common/intl"
import {MenuItemProps} from "../menu"
import Record, {MinimizedRecord} from "./Record"
import List from "./List"
import View from "./View"
import Start from "./Start"
import Save from "./Save"

export enum TrackPage {
	List,
	View,
	Start,
	Record,
	Save,
}

export type TTrackPageProps = {
  isShow: boolean
	goto: (page: TrackPage, param?: any) => void
  param?: any
	close: () => void
  open: () => void
  notifyError: (intlKey: string, error?: any) => void
}

const Track = ({isShow, close, open}: MenuItemProps): ReactElement => {
  const [notify, contextHolder] = notification.useNotification()
	const {track, settings} = useStore()
	const [page, setPage] = useState(TrackPage.List)
	const [param, setParam] = useState()

  const notifyError = (intlKey: string, error?: any) => {
    // @todo реализовать показ диалога об ошибке
    notify?.error({
      message: t(intlKey, error ? {error: error && error.message || (error.data && (error.data.detail || JSON.stringify(error.data)))} : {}),
      placement: 'top',
      className: "error-notification"
    })
  }

	const props: TTrackPageProps = {
		goto: (page, param?: any) => {
			setParam(param)
			setPage(page)
		},
    isShow,
		close,
    open,
    notifyError
	}

	const getPage = (props: TTrackPageProps) => {
		switch (page) {
			case TrackPage.List:
				return <List {...props} />
			case TrackPage.View:
				return <View {...props} />
			case TrackPage.Start:
				return <Start {...props} />
			case TrackPage.Record:
				return <Record {...props} />
			case TrackPage.Save:
				return <Save {...props} />
			default:
				return <></>
		}
	}

	return (
		<div className="track">
      {contextHolder}
			{getPage({...props, param})}
			{(!settings.isMobile || !isShow) && track.isRecording && <MinimizedRecord {...props} param={isShow} />}
		</div>
	)
}

export default observer(Track)
